import React, { Component } from 'react';
import Chart from '../../components/Chart';

class AdaptChart extends Component {
    shouldComponentUpdate(nextProps) {
        if (
            nextProps.data !== this.props.data ||
            nextProps.showLegend !== this.props.showLegend
        ) {
            return true;
        }
        return false;
    }

    render() {
        const { chartTypes, showLegend, data, unit, filename, stack, nameProp, onExport } = this.props;
        const { categories = [] } = data;
        const series = [];
        const yAxis = [];

        chartTypes.forEach((type, index) => {
            const list = data[`${type}sData`] || [];
            (Array.isArray(list) ? list : []).forEach(i => {
                if (type === 'column') {
                    i.type = 'column';
                    i.name = i[nameProp] || i.statisticName;
                } else {
                    i.type = 'spline';
                    i.marker = { enabled: false };
                    i.name = i[nameProp] || i.statisticName;
                }
                if (index !== 0) {
                    i.yAxis = 1;
                }
                series.push(i);
            });

            const params = { title: { text: '' } };
            if (unit && index === 0) {
                params.title = {
                    enabled: true,
                    align: 'high',
                    offset: -20,
                    text: `单位：${unit}`,
                    rotation: 0,
                    y: -12
                };
            }
            if (index !== 0) {
                params.opposite = true;
            }
            yAxis.push(params);
        });

        const settings = {};
        if (stack) {
            settings.plotOptions = {
                column: {
                    stacking: 'normal',
                }
            };
        }

        return (
            <div style={{ position: 'relative' }}>
                <Chart
                    filename={filename}
                    xAxis={{categories}}
                    yAxis={yAxis}
                    legend={{
                        enabled: showLegend
                    }}
                    series={series}
                    onExport={onExport}
                    {...settings}
                />
            </div>
        );
    }
}

export default AdaptChart;


// WEBPACK FOOTER //
// ./src/components/homePage/personIndicatorAnalysis/components/AdaptChart.js